import { Compass, Zap, LineChart, GraduationCap } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import serviceMappingImg from "@/assets/service-mapping.jpg";
import serviceOptimizationImg from "@/assets/service-optimization.jpg";
import serviceTrackingImg from "@/assets/service-tracking.jpg";
import serviceTrainingImg from "@/assets/service-training.jpg";

const Services = () => {
  const { t, language } = useLanguage();
  
  const services = [
    {
      icon: Compass,
      title: "services.mapping.title",
      description: "services.mapping.desc",
      image: serviceMappingImg,
      gradient: "from-sky-500 to-blue-600",
    },
    {
      icon: Zap,
      title: "services.optimization.title",
      description: "services.optimization.desc",
      image: serviceOptimizationImg,
      gradient: "from-purple-500 to-violet-600",
    },
    {
      icon: LineChart,
      title: "services.tracking.title",
      description: "services.tracking.desc",
      image: serviceTrackingImg,
      gradient: "from-amber-500 to-orange-600",
    },
    {
      icon: GraduationCap,
      title: "services.training.title",
      description: "services.training.desc",
      image: serviceTrainingImg,
      gradient: "from-emerald-500 to-green-600",
    },
  ];

  return (
    <section id="services" className="py-12 lg:py-16 bg-slate-50/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-slate-800 mb-2">
            {language === "fr" ? "Nos services" : "Our services"}
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto text-sm">
            {t("services.subtitle")}
          </p>
        </div>

        {/* Bento grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1 border border-slate-100"
            >
              {/* Glass shine effect - subtle */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none z-30">
                <div className="absolute inset-0 w-1/2 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shine" />
              </div>
              {/* Image container */}
              <div className="relative h-40 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={t(service.title)}
                  width={600}
                  height={160}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${service.gradient} opacity-30`} />
                
                {/* Icon badge */}
                <div className={`absolute top-4 left-4 w-10 h-10 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center shadow-lg`}>
                  <service.icon className="h-5 w-5 text-white" />
                </div>
              </div>
              
              {/* Content */}
              <div className="p-5">
                <h3 className="text-lg font-display font-semibold text-slate-800 mb-2">
                  {t(service.title)}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed">
                  {t(service.description)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
